import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { IParticipant } from 'APP/model/calendar/calendar.types';
import { User } from 'APP/store/Users/User/User';

import { CalendarParticipantAvatar } from '../../../components/CalendarParticipantAvatar/CalendarParticipantAvatar';
import { useParticipantsPresenter } from './Participants.presenter';
import styles from './Participants.styles.m.css';

interface IParticipantsProps {
  items: IParticipant[];
  itemsInfo: User[];
  providerEmail: string;
  initiatorEmail: string;
}

export const Participants: FC<IParticipantsProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useParticipantsPresenter(props);

  return (
    <div className={styles.container}>
      <div className={styles.count}>{presenter.count}</div>
      <div className={styles.statuses}>{presenter.statuses}</div>
      <div className={styles.participants}>
        {presenter.items.map((item) => {
          const userData = presenter.getUserData(item.email, props.providerEmail);
          const isShowInitiatorText = presenter.isShowInitiatorText(item.email);

          return (
            <div
              className={styles.participant}
              key={item.email}
            >
              <CalendarParticipantAvatar
                userData={userData}
                confirmationType={item.confirmationType}
              />
              <div className={styles.title}>{userData?.displayName || item.email || ''}</div>
              {isShowInitiatorText && (
                <div className={styles.initiator}>{`(${t('calendar_event_initiator')})`}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
});
